export const ROUTE_PATH = '/campaigns';
